//Performs a smooth page scroll to an anchor on the same page.
//Gets overriden by barba if it's not on the same page...
//Generell musste ich barba beibringen korrekt mit anchor links umzugehen... Bei neueren Versionen funktioniert das out of the box
$('.anchor-link').click(function() {
    var offset = 0; // <-- change the value here
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top + offset
            }, 1000);
            return false;
        }
    }
});

// $(".makeLetters, .caption, .type--heading, .main-nav__link, .news_detail_title").children().addBack().contents().each(function(){
//     if (this.nodeType == 3) { 
//         var $this = $(this);
//         $this.replaceWith($this.text().replace(/(\w|ö|Ö|ä|Ä|ü|Ü)/g, "<span class='letter_$&'>$&</span>"));
//     }
// });

$('li span').each(function(el){
  if(typeof this.style !== 'undefined') {
    $(this).parents('li').css('color',this.style.color)
  }
});

    
function cropText(paragraph, maxLength, phrase) {
    let cropped = '';
  
    // Remove HTML tags from the paragraph
    paragraph = paragraph.replace(/<[^>]*>/g, '');
  
    // Find the position of the phrase
    let phrasePos = paragraph.indexOf(phrase) + Math.floor(phrase.length / 2);
  
    // If the phrase is not found, return the original paragraph cropped to maxLength
    if (phrasePos === -1) {
        cropped = paragraph.substring(0, maxLength) + '...';
    } else {
        // Calculate the start and end positions for cropping
        let start = Math.max(0, phrasePos - Math.floor(maxLength / 2));
        let end = start + maxLength;
  
        // Ensure we don't exceed the paragraph length
        if (end > paragraph.length) {
            end = paragraph.length;
            start = Math.max(0, end - maxLength);
        }
  
        // Crop the paragraph
        cropped = paragraph.substring(start, end);
  
        // Ensure we don't cut off words at the end
        let lastSpace = cropped.lastIndexOf(' ');
        if (lastSpace !== -1) {
            cropped = cropped.substring(0, lastSpace);
        }
  
        // Ensure we don't cut off words at the start
        let firstSpace = cropped.indexOf(' ');
        if (firstSpace !== -1) {
            cropped = cropped.substring(firstSpace);
        }
  
        // Highlight the phrase
        cropped = '...' + cropped.replace(new RegExp(phrase, 'gi'), `<strong>${phrase}</strong>`) + '...';
    }
  
    return cropped.trim();
}
  //const croppedParagraph = cropParagraph(paragraph, 100, 'luptatum zzril');

  function initSearchNews() {
    newsCategories.forEach(function (value, index) {
        $('#news_search_form #news-c').append($('<option>', {
            value: index,
            text: value
        }));
    });
    newsYears.forEach(function (value, index) {
        $('#news_search_form #news-y').append($('<option>', {
            value: index,
            text: value
        }));
    });
    paginateNews(1);
    $('#news_search_form').submit( function( event ) {
        event.preventDefault();
        searchNews();
    });
    $('#news_search_form #news-t, #news_search_form #news-c, #news_search_form #news-y').change( function() {
        searchNews();
    });

    $('#news-reset').on( 'click', function( event ) {
        $('#news_search_form #news-t').val('');
        $('#news_search_form #news-y').val('0');
        $('#news_search_form #news-c').val('0');
        $('#news_search_form').submit();
    });
}

function searchNews() {
    $('.news-list-default-item').attr('data-display', 0);
    if ($('#news_search_form #news-t').val()!='') {
        $('.news-list-default-item[data-text*="' + $('#news_search_form #news-t').val() + '"]').attr('data-display', 1);
        $('.news-list-default-item p.news-item-teaser').hide();
        $('.news-list-default-item p.news-item-teaser-search').html('').show();
    } else {
        $('.news-list-default-item').attr('data-display', 1);
        $('.news-list-default-item p.news-item-teaser').show();
        $('.news-list-default-item p.news-item-teaser-search').html('').hide();
    }
    if ($('#news_search_form #news-c').val()>0 && $('#news_search_form #news-y').val()>0) {
        $('.news-list-default-item[data-categories!=",' + $('#news_search_form #news-c').val() + ',"]').attr('data-display', 0);
        $('.news-list-default-item[data-year!="' + $('#news_search_form #news-y').val() + '"]').attr('data-display', 0);
    } else if ($('#news_search_form #news-c').val()>0) {
        $('.news-list-default-item[data-categories!=",' + $('#news_search_form #news-c').val() + ',"]').attr('data-display', 0);
    } else if ($('#news_search_form #news-y').val()>0) {
        $('.news-list-default-item[data-year!="' + $('#news_search_form #news-y').val() + '"]').attr('data-display', 0);
    }
    paginateNews(1);
}

function paginateNews(p) {
    $('.news-list-default-item').hide();
    $('#no-news-found').hide();
    if (!$('.news-list-default-item[data-display=1]').length) {
        $('#no-news-found').show();
    }
    let firstNews = (p * newsItemsPerPage) - newsItemsPerPage + 1;
    let lastNews = firstNews + newsItemsPerPage - 1;
    let numberOfPages = Math.ceil($('.news-list-default-item[data-display=1]').length / newsItemsPerPage);
    let counter = 1;
    $('.news-list-default-item[data-display="1"]').each(function(el){
        if (counter>=firstNews && counter<=lastNews) {
            if ($('#news_search_form #news-t').val()!='') {
                let teaser = cropText($(this).data('text'), 120, $('#news_search_form #news-t').val());
                $(this).find('p.news-item-teaser-search').html(teaser);
            }
            $(this).show();
        }
        counter++;
    });
    $('#news-list-paginator').html('');
    if (numberOfPages>0) {
        let newsMaximumNumberOfLinksHalf = Math.floor(newsMaximumNumberOfLinks / 2);
        let firstPage = p - newsMaximumNumberOfLinksHalf;
        if (firstPage<1) {
            firstPage = 1;
        }
        let lastPage = firstPage + newsMaximumNumberOfLinksHalf + 1;
        if (lastPage > numberOfPages) {
            lastPage = numberOfPages;
        }
        if (lastPage == numberOfPages) {
            firstPage = numberOfPages - newsMaximumNumberOfLinksHalf -1;
            if (firstPage<1) {
                firstPage = 1;
            }
        }
        if (p>1) {
            $('#news-list-paginator').append($('<li>').attr('class', 'extra prev').append($('<a>').attr('href', 'javascript:paginateNews(' + (p-1) + ');').append('&nbsp;')));
        }
        if (firstPage>1) {
            let aclass = (p == 1)
                       ? 'active'
                       : '';
            $('#news-list-paginator').append($('<li>').append($('<a>').attr('href', 'javascript:paginateNews(1);').attr('class', aclass).append('1')));
            if (firstPage>2) {
                $('#news-list-paginator').append($('<li>').append('...'));
            }
        }
        for (let i = firstPage; i <= lastPage; i++) {
            let aclass = (i == p)
                       ? 'active'
                       : '';
            $('#news-list-paginator').append($('<li>').append($('<a>').attr('href', 'javascript:paginateNews(' + i + ');').attr('class', aclass).append(i)));
        }
        if (lastPage<numberOfPages) {
            if (lastPage<(numberOfPages-1)) {
                $('#news-list-paginator').append($('<li>').append('...'));
            }
            let aclass = (numberOfPages == p)
                       ? 'active'
                       : '';
            if (lastPage<numberOfPages) {
                $('#news-list-paginator').append($('<li>').append($('<a>').attr('href', 'javascript:paginateNews(' + numberOfPages + ');').attr('class', aclass).append(numberOfPages)));
            }
        }
        if (p<numberOfPages) {
            $('#news-list-paginator').append($('<li>').attr('class', 'extra next').append($('<a>').attr('href', 'javascript:paginateNews(' + (p+1) + ');').append('&nbsp;')));
        }
        newsActivePage = p;
    }
}

if ($('#news_search_form').length) {
    initSearchNews();
};
